import { render, staticRenderFns } from "./NavbarDynamicBars.vue?vue&type=template&id=08cbc6ba&scoped=true&"
import script from "./NavbarDynamicBars.vue?vue&type=script&lang=js&"
export * from "./NavbarDynamicBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cbc6ba",
  null
  
)

export default component.exports